
import { staticPagesMixin } from "~/mixins/staticPagesMixin.js";

export default {
  mixins: [staticPagesMixin],

  layout: "static_pages",

  head() {
    return {
      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.jsonld),
        },
      ],

      __dangerouslyDisableSanitizers: ["script"],
    };
  },

  computed: {
    h1() {
      return this.title;
    },

    schemaAttrs() {
      if (this.isPage("about-us")) {
        return {
          itemtype: "https://schema.org/AboutPage",
          itemscope: "",
        };
      }
      return {};
    },

    jsonld() {
      if (this.isPage("about-us")) {
        return {
          "@context": "http://schema.org",
          "@type": "AboutPage",
          mainEntity: {
            "@type": "WebPage",
            "@id": `${this.$config.baseUrlApp}${this.$route.path}`,
            name: "About Emiratescort",
            description: this.seoTexts?.description,
          },
        };
      }
      return {};
    },
  },
};
